import React from 'react'
import type {
  KambiSportsEventDetails,
  KambiSportsSameGameMultiSelection,
} from '@mobi/betslip/types'
import { spacing } from '@mobi/component-library/Foundations'
import { Icon } from '@mobi/component-library/Legacy/Icon/Icon'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { TeamsIcon } from '@mobi/sports-offering/Components/Common/TeamsIcon'
import { EventInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/EventInfo'
import { SecondaryInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SecondaryInfo'
import { SelectionInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SelectionInfo'
import { SelectionOverflow } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SelectionOverflow'
import { getSelectionNameFromKambiBetOffer } from '@core/Areas/Quickbet/helpers/selectionsKambi'

export const KambiSportsHeaderSameGameMulti: React.FC<{
  selection: KambiSportsSameGameMultiSelection
  eventDetails: KambiSportsEventDetails
}> = ({ selection, eventDetails }) => {
  const sgmLegCount = selection.betOffers.length
  const event = eventDetails.events[0]
  const sportName = event?.sport

  return (
    <Flex flexDirection='column' gap={spacing.sm}>
      <EventInfo
        icon={<Icon type='tab' size='2.2rem' />}
        eventInfo={eventDetails.events[0].englishName}
      />

      <SecondaryInfo
        marketInfo={`${sgmLegCount} Leg Same Game Multi`}
        eventStart={eventDetails.events[0].start}
      />

      <SelectionOverflow shouldRestrictHeight={sgmLegCount > 3}>
        <Flex flexDirection='column' gap={spacing.smx1}>
          {selection.betOffers.map(betOffer => (
            <SelectionInfo
              key={betOffer.id}
              leftSlot={
                <div
                  style={{
                    width: '3rem',
                    height: '3rem',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                    borderRadius: '50%',
                    background: '#47245D',
                    flexShrink: 0,
                  }}
                >
                  <TeamsIcon
                    participantId={betOffer.outcomes[0].participantId}
                    betOfferId={betOffer.id}
                    betOfferType={betOffer.betOfferType.id}
                    outcomeId={betOffer.outcomes[0].id}
                    size='xxs'
                    sportName={sportName}
                  />
                </div>
              }
              text={getSelectionNameFromKambiBetOffer(betOffer)}
              subText={betOffer.criterion.label}
            />
          ))}
        </Flex>
      </SelectionOverflow>
    </Flex>
  )
}
